/**
 *  @fileOverview ATAR results module, initalises ATAR results table
 *  Table sort libray can be found here https://github.com/tristen/tablesort
 *
 *  @author       Chris Hill
 *
 */

function ATARresultsModule (axios, tablesort) {
  /**
   * @description Initialises ATAR results instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Setup promise so that the dependant modules can wait till promise is returned
     */
    return new Promise((resolve, reject) => {
      /**
       * Check that atar results element is present
       */
      if (document.querySelector('[data-table="tableATAR"]') !== null) {
        /**
         * Target the div to insert table into
         */
        const atardiv = document.querySelector('[data-table="tableATAR"]')

        let url = 'https://www.ecu.edu.au/degrees/shared-content/nested-content/funnelback-json-course-info'

        /**
         * Retrieve unit info from Funnelback via WebCMS rest object
         */
        axios.get(url)
          .then(response => {
            /**
             * Filter course list down to only bachelor courses with ATAR values
             */
            const courses = response.data.results.filter((course) => {
              return course.atar !== ''
            })

            /**
             * Build table HTML
             */
            var html = `<table class="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col" role="columnheader" class="tableSort__title" data-sort-default>Course Title</th>
                              <th scope="col" role="columnheader" class="tableSort__col">Indicative ATAR</th>
                              <th scope="col" role="columnheader" class="tableSort__col">Course Code</th>
                            </tr>
                          </thead>
                          <tbody>`

            courses.forEach((course, i) => {
              html += `     <tr>
                              <td>
                                <a href="${course.courseURL}">${course.courseNationalCode === '' ? course.courseTitle : `${course.courseNationalCode} - ${course.courseTitle}`}</a>
                              </td>
                              <td>${course.atar}</td>
                              <td>${course.courseCode}</td>
                            </tr>`
            })

            html += `     </tbody>
                        </table>`

            /**
             * Insert into div
             */
            atardiv.innerHTML = html

            /**
             * Apply table sort to teh new table
             */
            tablesort(atardiv.querySelector('table'))

            /**
             * Resolve promise so dependant code can be excecuted
             */
            resolve('Success')
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        resolve('No ATAR Results to show')
      }
    })
  }
}

module.exports = ATARresultsModule
